import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/Vuetify";
import Axios from "axios";
import VueAxios from "vue-axios";
import "tiptap-vuetify/dist/main.css";
import "vuetify/dist/vuetify.min.css";
import GlobalMixin from "@/mixins";
import vueMoment from 'vue-moment';

Vue.use(vueMoment);
Vue.use(VueAxios, Axios);
Axios.defaults.baseURL = process.env.VUE_APP_ROMA_PLANNER_API_URL;
Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
Vue.mixin(GlobalMixin);

// add cookies to axios
Axios.defaults.withCredentials = true;

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
